import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private toastr: ToastrService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('AUTH_TOKEN');

    const modifiedReq = req.clone({
      setHeaders: {
        Authorization: token ? `Bearer ${token}` : '',
        'token-type': 'jwt',
      },
    });
    return next.handle(modifiedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'An error occurred';

        if (error.status != 401) {
          if (error.error && error.error.message) {
            this.toastr.error(error.error.message);
          }
        }
        if (error.status === 0) {
          if (!navigator.onLine) {
            this.toastr.warning('No internet connection. Please check your connection and try again');
          } else {
            this.toastr.warning('Sorry, something went wrong');
          }
        }


        return throwError(() => error);
      })
    );
  }
}
